export const RER_AUDIT_ENTITY = 'custom_rer_request_audit';

export const RER_AUDIT_SOURCE_FIELDS = [
  'code',
  'pricing_action',
  'change_reason',
  'old_price',
  'suggested_future_price',
  'current_price',
  'current_effective_date',
  'notes',
] as const;

export const RER_PA_HISTORY_ENTITIES = new Set([
  RER_AUDIT_ENTITY,
]);

export function mapRerAuditSourceData(record: any): Record<string, any> {
  let sourceRecord: Record<string, any> | null = null;

  try {
    const parsedSource = typeof record?.source_data === 'string'
      ? JSON.parse(record.source_data)
      : record?.source_data;
    const firstSourceRecord = Array.isArray(parsedSource) ? parsedSource[0] : parsedSource;
    if (firstSourceRecord && typeof firstSourceRecord === 'object' && !Array.isArray(firstSourceRecord)) {
      sourceRecord = firstSourceRecord;
    }
  } catch {
    sourceRecord = null;
  }

  // The audit endpoint normally wraps the business row in source_data. Keep a
  // direct-record fallback for malformed or already-normalized responses.
  const source = sourceRecord || (record && typeof record === 'object' ? record : {});
  const aliases: Partial<Record<(typeof RER_AUDIT_SOURCE_FIELDS)[number], string[]>> = {
    current_price: ['new_price', 'price'],
    current_effective_date: ['new_effective_date', 'effective_date'],
  };

  return RER_AUDIT_SOURCE_FIELDS.reduce((mappedRecord, fieldKey) => {
    const candidateKeys = [fieldKey, ...(aliases[fieldKey] || [])];
    const value = candidateKeys
      .map((key) => source?.[key])
      .find((candidate) => candidate !== null && candidate !== undefined && candidate !== '');
    mappedRecord[fieldKey] = value === null || value === undefined || value === '' ? '-' : value;
    return mappedRecord;
  }, {} as Record<string, any>);
}
